import React, { useState, useEffect } from "react";
import AffiliateLayout from "./layout";
import axios from "axios";
import { END_POINT } from "../../constants/defaultValues";
import moment from "moment";

const Commissions = () => {
  const [commissions, setCommissions] = useState([]);
  const [filter, setFilter] = useState("ALL");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [filter]);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("affiliate_token");
      const res = await axios.get(`${END_POINT}/api/affiliate/commissions`, {
        headers: { "x-auth-token": token },
        params: { status: filter },
      });

      if (res.status === 200) {
        setCommissions(res.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching commissions:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (val) => {
    return new Intl.NumberFormat("vi-VN").format(val);
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "approved":
        return <span className="status-badge approved">Đã duyệt</span>;
      case "paid":
        return <span className="status-badge paid">Đã thanh toán</span>;
      case "pending":
        return <span className="status-badge pending">Chờ duyệt</span>;
      case "cancelled":
      case "rejected":
        return <span className="status-badge rejected">Đã hủy</span>;
      default:
        return <span className="status-badge">{status}</span>;
    }
  };

  return (
    <AffiliateLayout title="Hoa hồng">
      <div className="aff-page-container">
        <div className="page-header">
          <h2>Hoa hồng & Thu nhập</h2>
          <p>Theo dõi chi tiết các khoản hoa hồng từ giới thiệu của bạn.</p>
        </div>

        <div className="aff-card">
          <div className="card-header">
            <h3>Lịch sử hoa hồng</h3>
            <div className="header-actions">
              <select
                className="px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-emerald-500"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                <option value="ALL">Tất cả trạng thái</option>
                <option value="approved">Đã duyệt</option>
                <option value="pending">Chờ duyệt</option>
                <option value="paid">Đã thanh toán</option>
                <option value="rejected">Đã hủy</option>
              </select>
            </div>
          </div>
          <div className="aff-table-container">
            <table>
              <thead>
                <tr>
                  <th>Mã đơn hàng</th>
                  <th>Khách hàng</th>
                  <th>Giá trị đơn</th>
                  <th>Tỷ lệ</th>
                  <th>Hoa hồng</th>
                  <th>Ngày ghi nhận</th>
                  <th>Trạng thái</th>
                </tr>
              </thead>
              <tbody>
                {commissions.length > 0 ? (
                  commissions.map((item) => {
                    const orderValue = parseFloat(item.conversion?.amount || 0);
                    const commissionValue = parseFloat(item.amount || 0);
                    const rate =
                      orderValue > 0
                        ? ((commissionValue / orderValue) * 100).toFixed(0)
                        : 0;

                    return (
                      <tr key={item.id}>
                        <td>
                          <span className="font-mono text-slate-600">
                            {item.conversion?.reference_id ||
                              `#${item.conversion_id?.split("-")[0]}`}
                          </span>
                        </td>
                        <td>
                          {item.conversion?.customer?.name || "Khách vãng lai"}
                        </td>
                        <td className="text-slate-600">
                          {formatCurrency(orderValue)} đ
                        </td>
                        <td className="text-slate-500">{rate}%</td>
                        <td className="font-bold text-emerald-600">
                          +{formatCurrency(commissionValue)} đ
                        </td>
                        <td>{moment(item.createdAt).format("DD/MM/YYYY")}</td>
                        <td>{getStatusBadge(item.status)}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      Chưa có dữ liệu hoa hồng
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AffiliateLayout>
  );
};

export default Commissions;
